import { useQuery, useMutation } from "@apollo/client";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Accordion, Button, Text, Title, Divider, Stack, Table, Grid } from "@mantine/core";
import APICard from "../../components/assets/APICard/APICard";
import { CURRENT_USER } from "../../queries/auth";
import "./ProfilePage.css";
import { ADD_LOG } from "../../queries/user-analytics"; // added for tracking user data
import { logPageView} from "../../helpers/useGA"

export default function ProfilePage() {
  const { loading, error, data } = useQuery(CURRENT_USER);
  const [user, setUser] = useState(null);
  const isMobile = useMediaQuery('(max-width: 1090px)');
  const location = useLocation();

  // added for tracking user data
  const [logEventMutation] = useMutation(ADD_LOG, {
    onCompleted: ({ addLog }) => {
        // Access the HTTP response directly
        const { status, message } = addLog;
        if (status === "success") {
            console.log("Event logged successfully:", message);
        } else {
            console.error("Failed to log event:", message);
        }
    },
    onError: (error) => {
        console.error("Error logging event:", error.message);
    }
});

const logEvent = (eventType, additionalData, _userid) => {
    const eventData = {
        userid: Number(_userid),
        event_type: eventType,
        timestamp: new Date().toISOString(),
        additional_data: JSON.stringify(additionalData)

    };

    logEventMutation({ variables: eventData });
};

  useEffect(() => {
      if (loading) console.log('Loading user...')
      else if (error) { setUser(null) }
      else {
        setUser(data.currentUser);
        console.log("User:", user);
        logEvent('ProfilePage', data.currentUser, data.currentUser.userid); // added for tracking user data
        const pageTitle = "Profile Page"
        document.title = pageTitle; // Update document title
        logPageView(location.pathname + location.search, pageTitle); // Ensure this function is properly set up in your GA helper
      }
  }, [loading, error, data, location.pathname, location.search])

  return (
    <Stack spacing={20}>
      <div>
        <Title order={2}>Personal information</Title>
        <Divider size='xs' my="xl" />
        <Grid columns={24} p="sm">
          <Grid.Col span={isMobile ? 24: 12} className="spot-component-wrapper">
            <Table ml='md' my="md">
              <tr>
                <td><b>Full Name</b></td>
                <td>{user == null ? "NA" : user.name}</td>
              </tr>
              <tr>
                <td><b>Username</b></td>
                <td>{user == null ? "NA" : user.alias}</td>
              </tr>
              <tr>
                <td><b>Email Address</b></td>
                <td>{user == null ? "NA" : user.email}</td>
              </tr>
            </Table>
          </Grid.Col>
        </Grid>
      </div>
      <div>
        <Title order={2}>Account Setting</Title>
        <Divider size='xs' my="xl" />
        <Accordion transitionDuration={1000}>
          <Accordion.Item value="api_key" sx={{ backgroundColor: 'var(--color-grey-200)' }}>
            <Accordion.Control>
              <Text size="sm" weight={500}>
                API Key
              </Text>
            </Accordion.Control>
            <Accordion.Panel sx={{ backgroundColor: "white" }}>
              <APICard />
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </div>
      <div>
        <Title order={2}>Help Center</Title>
        <Divider size='xs' my="xl" />
        <Grid columns={24} align="center">
          <Grid.Col span={12}>
            <Text align="left"><b>Support Email Address</b></Text>
          </Grid.Col>
          <Grid.Col span={12}>
            <Text align="right">disresh@nus.edu.sg, gettyrl@nus.edu.sg</Text>
          </Grid.Col>
          <Grid.Col span={12}>
            <Text align="left"><b>How to use the website?</b></Text>
          </Grid.Col>
          <Grid.Col span={12} style={{ textAlign: 'right' }}>
            <Button component="a" href="/tutorial" target="_blank" onMouseOver={(e) => (e.currentTarget.style.color = 'white')}>Access Tutorial</Button>
          </Grid.Col>
        </Grid>
      </div>
    </Stack>
  );
}